// extracted by mini-css-extract-plugin
export default {"container":"ActionBar_container__VG9pV","spacer":"ActionBar_spacer__ZWLKZ"};